'use client';

import dynamic from 'next/dynamic';
import { SearchSkeleton } from './search';

// Dynamically import components that use useSearchParams with suspense
export const MobileMenu = dynamic(() => import('./mobile-menu'), {
  ssr: false,
  loading: () => <div className="h-10 w-10 animate-pulse rounded-md bg-neutral-200 dark:bg-neutral-800"></div>
});

export const SearchComponent = dynamic(() => import('./search'), {
  ssr: false,
  loading: () => <SearchSkeleton />
});

export const CollapsibleSearchComponent = dynamic(() => import('./collapsible-search'), {
  ssr: false,
  loading: () => (
    <div className="flex h-10 w-10 items-center justify-center rounded-md border border-neutral-700 bg-[#1E1E1E] animate-pulse">
      <div className="h-4 w-4 bg-neutral-600 rounded-full"></div>
    </div>
  )
});

// Dynamically import the mega menu to reduce initial JS bundle size
export const ShadcnMegaMenuComponent = dynamic(() => import('./shadcn-mega-menu'), {
  ssr: false,
  loading: () => <div className="h-10 animate-pulse rounded-md bg-neutral-800 w-[300px]"></div>
});
